// extracted by mini-css-extract-plugin
export var brandIcon = "GLsLm";
export var microsoft365UpsellBadge = "AGceM";
export var microsoft365UpsellIcon = "AAXzM";